<template>
  <div class="invoiceDetail">
    <el-dialog
      title="开票信息"
      class="invoiceDialog"
      :visible.sync="visible"
      width="400px"
      :before-close="close"
      :append-to-body="appendToBody">
      <div class="content" v-loading="loading">
        <div class="info">
          <div class="info_item">
            <div class="info_item_label">姓名：</div>
            <div class="info_item_value">{{ info.patientName }}</div>
          </div>
          <div class="info_item">
            <div class="info_item_label">手机号：</div>
            <div class="info_item_value">{{ info.patientPhone }}</div>
          </div>
          <div class="info_item">
            <div class="info_item_label">诊号：</div>
            <div class="info_item_value">{{ info.uniOrderNumber }}</div>
          </div>
          <div class="info_item">
            <div class="info_item_label">收费时间：</div>
            <div class="info_item_value">{{ info.payDate }}</div>
          </div>
          <div class="info_item">
            <div class="info_item_label">开票金额：</div>
            <div class="info_item_value">{{ info.amount }}</div>
          </div>
          <div class="info_item">
            <div class="info_item_label">开票状态：</div>
            <div class="info_item_value" :style="{ color: statusMap[info.status].color }">{{ statusMap[info.status].label }}</div>
          </div>
        </div>
        <div class="invoice">
          <div class="invoice_tips">请扫描下方二维码开具发票</div>
          <div class="invoice_code">
            <div ref="qrcode" class="invoice_code_img"></div>
          </div>
        </div>
      </div>
      <div slot="footer" class="footer">
        <el-button v-if="info.status === 1" type="primary" @click="toPrint">打印开票凭证</el-button>
        <el-button @click="close">关 闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import req from '@/utils/request'
  import QRCode from 'qrcodejs2'

  export default {
    name: 'InvoiceDetail',
    props: {
      appendToBody: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        visible: false,
        loading: false,
        orderId: '',
        statusMap: {
          1: { label: '未开票', color: '#FE8F1F' },
          2: { label: '已开票', color: '#667182' }
        },
        info: {
          patientName: '',
          patientPhone: '',
          uniOrderNumber: '',
          payDate: '',
          amount: '',
          status: 1,
          qrcodeUrl: ''
        },
        qrcode: null
      }
    },
    methods: {
      async getDetail () {
        this.loading = true
        const res = await req.get('/invoice/queryInvoicePlatform', { orderId: this.orderId })
        this.loading = false
        if (res.code === 200) {
          this.info.patientName = res.data.patientName || ''
          this.info.patientPhone = res.data.patientPhone || ''
          this.info.uniOrderNumber = res.data.uniOrderNumber || ''
          this.info.payDate = res.data.payDate && new Date(res.data.payDate).Format('yyyy-MM-dd hh:mm:ss') || ''
          this.info.amount = res.data.amount || ''
          this.info.status = res.data.status || 1
          this.info.qrcodeUrl = res.data.qrcodeUrl || ''

          if (![null, undefined, ''].includes(this.info.qrcodeUrl)) {
            this.$nextTick(() => {
              this.crateQrcode()
            })
          }
        }
      },
      crateQrcode () {
        this.qrcode = new QRCode(this.$refs['qrcode'], {
          width: 140,
          height: 140,
          text: this.info.qrcodeUrl
        })
      },
      open(orderId) {
        this.orderId = orderId
        this.visible = true
        this.getDetail()
      },
      close () {
        this.info.patientName = ''
        this.info.patientPhone = ''
        this.info.uniOrderNumber = ''
        this.info.payDate = ''
        this.info.amount = ''
        this.info.status = 1
        this.info.qrcodeUrl = ''
        this.$refs['qrcode'].innerHTML = ''
        this.visible = false
      },
      toPrint () {
        this.$emit('print', this.orderId)
      }
    }
  }
</script>

<style lang="less" scoped>
  .invoiceDetail {}

  .invoiceDialog /deep/ .el-dialog__header {
    padding: 16px 20px;
  }

  .invoiceDialog /deep/ .el-dialog__body {
    padding: 20px 24px;
  }

  .content {
    width: 100%;
  }

  .info {
    width: 100%;
  }

  .info_item {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
  }

  .info_item_label {
    flex-shrink: 0;
    width: 70px;
    line-height: 24px;
    text-align: right;
    font-size: 14px;
    color: #000000;
  }

  .info_item_value {
    flex-grow: 1;
    line-height: 24px;
    font-size: 14px;
    color: #000000;
  }

  .invoice {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    margin: 12px 0 0 0;
    width: 100%;
  }

  .invoice_tips {
    line-height: 20px;
    font-size: 14px;
    color: #000000;
  }

  .invoice_code {
    margin: 12px 0 0 0;
    padding: 10px;
    border: 1px solid #EBEAEE;
    border-radius: 6px;
  }
</style>